export default "__VITE_ASSET__Agh0gZov__"